import { render, staticRenderFns } from "./tip-label.vue?vue&type=template&id=6d2b1664&"
import script from "./tip-label.vue?vue&type=script&lang=js&"
export * from "./tip-label.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports